<template>
  <div>
    <div class="top-bar"
         :style="uploadList.length > 0 || (initFileList && initFileList.length >0) ? '' : 'border-bottom: 1px solid #ebeef5;'">
      <span>附件<span v-if="uploadList.length > 0">({{ uploadList.length }})</span></span>
      <Upload
          v-if="isEdit"
          class="upload"
          ref="upload"
          :show-upload-list="false"
          :default-file-list="defaultList"
          :on-success="handleSuccess"
          :before-upload="handleBeforeUpload"
          :action="actionUrl"
          :format="['jpg','jpeg','png', 'pdf','xlsx','xls','doc','docx']"
          :on-format-error="handleFormatError"
          :headers="uploadHeaders"
          multiple
          type="drag">
        <Button type="primary" icon="md-cloud-upload" style="border-radius: 4px;height: 30px;">上传</Button>
      </Upload>
    </div>
    <vxe-table
        v-if="uploadList.length > 0 || (initFileList && initFileList.length >0)"
        border
        show-overflow
        keep-source
        ref="fileTable"
        :data="uploadList"
        class="table-upload-style table-style"
        max-height="200"
        :auto-resize="true"
        :edit-config="{ trigger: 'click', mode: 'cell', showIcon: false }"
    >
      <vxe-table-column width="60" align="center" type="seq" title="序号"></vxe-table-column>
      <vxe-table-column field="name" title="名称">
        <template v-slot="{ row,$rowIndex }">
          <div style="display: flex;align-items: center;">
            <img v-if="row.name.indexOf('.jpg') > -1 || row.name.indexOf('.jpeg') > -1 || row.name.indexOf('.png') > -1"
                 src="@/assets/images/upload/jpg.png"/>
            <img v-if="row.name.indexOf('.doc') > -1 || row.name.indexOf('.docx') > -1"
                 src="@/assets/images/upload/doc.png"/>
            <img v-if="row.name.indexOf('.pdf') > -1" src="@/assets/images/upload/pdf.png"/>
            <img v-if="row.name.indexOf('.xls') > -1 || row.name.indexOf('.xlsx') > -1"
                 src="@/assets/images/upload/xls.png"/>
            <a @click="checkFile(row,$rowIndex)" target="_black"
               style="cursor: pointer;margin-left: 10px;">{{ row.name }}</a>
            <Icon type="ios-close-circle" size="16" color="#c0c3cb" @click.native="handleRemove($rowIndex)"
                  v-if="isEdit"></Icon>
          </div>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div class="show-pic" v-if="isShowPicBox">
      <picture-viewer
          v-if="lookImageData && lookImageData.length > 0"
          :imgData="lookImageData"
          :picIndex="showPicIndex"
          @close="isShowPicBox = false"
      ></picture-viewer>
    </div>
  </div>
</template>
<script>
import auth from "@/utils/auth";
import PictureViewer from "@/components/common/PictureViewer";
import {hideLoading, isNotEmpty, showLoading} from "@/utils/util";

const union = (...arr) => [...new Set(arr.flat())];
const assign = (o) => Object.assign({}, o);
const empties = [undefined, "", null, "null", {}, []];

export default {
  components: {
    PictureViewer
  },
  props: {
    row: {
      type: Object,
      default: null,
    },
    initFileList: {
      type: Array,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      uploadList: [],
      defaultList: [], // 默认图片
      actionUrl: "",
      uploadHeaders: {
        Authorization: auth.getAuth().token,
        token: auth.getAuth().token,
      },
      isShowPicBox: false,
      lookImageData: [],
      showPicIndex: 0,
    }
  },
  mounted() {
    this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
  },
  watch: {
    initFileList: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val) {
          this.init(val);
        }
      },
    },
  },
  methods: {
    setList(addUrlList) {
      this.defaultList = addUrlList;
      this.uploadList = [];
      this.uploadList = union(this.uploadList, this.defaultList);
    },
    init(initFileList) {
      // 编辑时 设置response属性
      this.uploadList = [];
      this.defaultList = [];
      if (initFileList && initFileList.length > 0) {
        initFileList.forEach((item) => {
          item.status = "finished";
          item.percentage = 100;
          if (empties.includes(item.oldFileName)) {
            item.oldFileName = item.oldName;
          } else {
            item.oldName = item.oldFileName;
          }
          item.name = item.oldName ? item.oldName : item.response.data ? item.response.data.oldName : null;
          if (empties.includes(item.response)) {
            item.response = {};
            item.response.data = {};

            let url = item.url ? item.url : item.response.data.url;
            let uuid = item.uuid ? item.uuid : item.response.data.uuid;
            let oldName = item.oldName ? item.oldName : item.response.data.oldName;
            item.response = {
              data: {
                url,
                uuid,
                oldName,
              },
            };
          }
          this.defaultList.push(assign(item));
        });
      }
      this.uploadList = union(this.uploadList, this.defaultList);
      this.returnFileUuidList();
    },
    handleBeforeUpload(file) {
      showLoading();
      if (file.size > 3072000) {
        this.$XModal.alert({
          message: "单个附件大小不能超过3M，请压缩后上传",
          status: "error",
        });
        hideLoading();
        return false;
      }
      // let maxFileNum = this.maxLength ? this.maxLength : 5;
      // if (this.$refs.upload.fileList.length > maxFileNum) {
      //   this.$XModal.alert({
      //     message: "最多只能上传" + maxFileNum + "张",
      //     status: "error",
      //   });
      //   return false;
      // }
      this.uploadList = this.$refs.upload.fileList;
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc:
            "文件 " +
            file.name +
            " 格式不正确，请上传 jpg 或 png 或 jpeg 格式的图片, pdf、doc、docx、xlsx、xls格式的文件。",
      });
      hideLoading();
    },
    async handleRemove(i) {
      this.$XModal.confirm("您确定要删除该附件吗？").then((type) => {
        if (type === "confirm") {
          this.$refs.upload.fileList.splice(i, 1);
          this.uploadList = this.$refs.upload.fileList;
          this.$emit("fileList", this.uploadList);
          this.returnFileUuidList();
        }
      });
    },
    handleSuccess(res, file) {
      hideLoading();
      if (res && res.status === 200 && res.data) {
        this.$emit("fileList", this.uploadList);
        this.returnFileUuidList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    returnFileUuidList() {
      let uuidList = [];
      this.uploadList.forEach((item) => {
        if (item.response && item.response.data) {
          uuidList.push(item.response.data.uuid);
        } else {
          uuidList.push(item.uuid);
        }
      });
      if (this.row) {
        this.row.fileUuidList = uuidList;
      } else {
        this.row.fileUuidList = [];
      }
      if (this.row.fileNewList) {
        this.row.fileNewList = this.uploadList;
      } else {
        this.row.fileNewList = [];
      }
    },
    checkFile(row, i) {
      if (row.name.indexOf('.jpg') > -1 || row.name.indexOf('.jpeg') > -1 || row.name.indexOf('.png') > -1) {
        this.getBigPic(i);
      } else if (row.name.indexOf('.pdf') > -1 || row.name.indexOf('.xls') > -1 || row.name.indexOf('.xlsx') > -1) {
        window.open(row.response.data.url)
      } else if (row.name.indexOf('.doc') > -1 || row.name.indexOf('.docx') > -1) {
        let url = encodeURIComponent(row.response.data.url)
        let officeUrl = 'http://view.officeapps.live.com/op/view.aspx?src=' + url
        window.open(officeUrl, '_target');
      }
    },
    getBigPic(i) {
      this.lookImageData = [];
      this.uploadList.forEach((item, index) => {
        let regPdf = /(.pdf)$/i;
        let regDoc = /(.doc)$/i;
        let regDocx = /(.docx)$/i;
        let regXls = /(.xls)$/i;
        let regXlsx = /(.xlsx)$/i;
        if (!regPdf.test(item.name) && !regDoc.test(item.name) && !regDocx.test(item.name) && !regXls.test(item.name) && !regXlsx.test(item.name)) {
          item.name = item.name || item.response.data.oldName;
          item.url = item.response.data.url;
          item.bigImgUrl = item.response.data.url;
          this.lookImageData.push(item);
          if (index == i) {
            this.showPicIndex = this.lookImageData.length - 1;
          }
        }
      });
      this.isShowPicBox = true;
    },
  }
}
</script>
<style scoped>

.top-bar {
  display: flex;
  align-items: center;
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  height: 30px;
  padding: 0 12px;
  box-sizing: border-box;
}

.upload {
  margin-left: auto;
}

.upload >>> .ivu-upload-drag {
  border: none;
}
</style>